import React from 'react';
import { frontEndSkills, backEndSkills, miscSkills } from '../data/skillLists';

import Skill from './Skill';

const Skills = () => {
    return (
        <section id='skills'>
            <h2 className='section-header'>Skills</h2>
            <div className='skills-container'>
                <Skill 
                    iconClass='fas fa-desktop'
                    skillName='Front End'
                    skills={frontEndSkills}
                />
                <Skill
                    iconClass='fas fa-database'
                    skillName='Back End'
                    skills={backEndSkills}
                />
                <Skill 
                    iconClass='fas fa-code-branch'
                    skillName='Miscellaneous'
                    skills={miscSkills}
                />
            </div>
        </section>
    )
}

export default Skills;